<template>
  <div class='manage'>
    <!-- 页面顶部板块 -->
    <div class="top">
      <el-header>
        <Head-top></Head-top>
      </el-header>
    </div>
    <el-container style="padding-left:10px">
      <!-- 页面左侧菜单板块 -->
      <div class="sidebar" :style="'background:linear-gradient(' + theme.top + ',' + theme.bottom + ');'">
        <el-popover placement="bottom-start" trigger="manual" v-model="popoverVisible" v-if="!isCollapse">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText" size="small" style="margin-bottom: 8px">
          </el-input>
          <!-- <el-tree :data="gardenAreaByStaff" :props="defaultProps" :filter-node-method="filterNode" ref="tree"
            @node-click="handleNodeClick" :default-expanded-keys="expandedKeys" :highlight-current="true"
            :expand-on-click-node="false" default-expand-all>
          </el-tree> -->
          <!-- 添加全部小区选项 -->
          <div class="all-garden" v-if="staffId == 100006" :class="{'is-selected': myGarden == 0}" @click="handleAllGarden">
            <span :class="{'is-selected': myGarden == 0}">全部小区</span>
          </div>
          <!--  左侧树组件 -->
          <el-tree :data="gardenAreaByStaff" :props="defaultProps" :filter-node-method="filterNode" ref="tree"
            @node-click="handleNodeClick" :default-expanded-keys="expandedKeys" node-key="name"
            :highlight-current="true" :expand-on-click-node="true" accordion>
          </el-tree>
          <!-- <el-select slot="reference" v-model="selectedName" placeholder="请选择" class="gardenSelect"
            :popper-append-to-body="false">
            <el-option :value="selectedName" :label="selectedName">
            </el-option>
          </el-select> -->
          <div slot="reference" class="gardenSelect" @click="popoverVisible = !popoverVisible"
            style="display: flex;align-items: center;cursor: pointer;border: 1px solid #dcdfe6;border-radius: 4px;height: 32px;padding: 0 10px;box-sizing: border-box; background: #fff;width: 180px;">
            <span style="flex:1;">{{ selectedName || '请选择' }}</span>
            <i class="el-icon-arrow-down" :style="{transform: popoverVisible ? 'rotate(180deg)' : ''}"></i>
          </div>
        </el-popover>
        <el-aside class="z-aside">
          <el-menu :collapse="isCollapse" class="el-menu-vertical-demo" text-color="#fff" active-text-color="#ffd04b"
            :unique-opened="true" :default-active="open_menu" :default-openeds="openeds">
            <el-menu-item index="homePage" @click="routeJump('homePage', '首页')" class="home">
              <i class="el-icon-s-home"></i>
              <span slot="title">首页</span>
            </el-menu-item>
            <template v-for="subItem in menuList">
              <el-submenu v-if="subItem.children && subItem.children.length != 0" :key="subItem.id"
                :index="subItem.name + ''">
                <template slot="title">
                  <i v-for="item in $t('lang.menu')" :key="item.name">
                    <i v-if="item.name === subItem.id" class="iconfont" :class="item.url"></i>
                  </i>
                  <span slot="title">
                    {{ subItem.name }}
                  </span>
                </template>
                <el-menu-item :draggable="true" :index="items.id + ''" @click="routeJump(items.route, items.name)"
                  v-for="items in subItem.children" :key="items.id"
                  :class="{'menuPro': menuProArr.includes(items.name) }">
                  <i class="el-icon-star-on" v-if="menuProArr.includes(items.name)"></i>
                  <span slot="title">{{ items.name }}</span>
                </el-menu-item>
              </el-submenu>
            </template>
          </el-menu>
        </el-aside>
        <div class="hiddenBtn" :style="'background: linear-gradient(90deg,' + theme.bottom + ',' + theme.top + ');'"
          @click="isCollapse = false" v-if="isCollapse">
          <i class="el-icon-arrow-left iconicon"></i>
        </div>
        <div class="hiddenBtn" :style="'background: linear-gradient(90deg,' + theme.bottom + ',' + theme.top + ');'"
          @click="isCollapse = true" v-if="!isCollapse">
          <i class="el-icon-arrow-right iconicon"></i>
        </div>
      </div>
      <!-- 页面内容body -->
      <!-- 杜，增加备案号修改样式 -->
      <!-- <el-container class="frame-body"> -->
      <el-container class="frame-body" style="height:100%">
        <!-- tabs的操作栏 -->
        <el-dropdown @command="handleCommand" class="closeTabs" v-if="editableTabs.length > 0">
          <span class="el-dropdown-link">
            {{$t('lang.lab_operation')}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a">{{$t('lang.lab_closeNow')}}</el-dropdown-item>
            <el-dropdown-item command="b">{{$t('lang.lab_closeAll')}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- 页面tabs显示位置， 要把el-main包起来，或者在el-main里面都行 -->
        <el-tabs v-model="editableTabsValue" type="card" closable @tab-remove="removeTab"
          @tab-click="jumpOtherTabs(editableTabsValue)" :lazy="true">
          <el-tab-pane :key="item.route" v-for="item in editableTabs" :label="item.title" :name="item.route">
          </el-tab-pane>
        </el-tabs>
        <!-- 切换tabs时页面被执行多次 -->
        <el-main>
          <!-- 杜，keepAlive -->
          <keep-alive :include="includeArr">
            <router-view></router-view>
          </keep-alive>
          <!-- <router-view></router-view> -->
        </el-main>
      </el-container>
    </el-container>
    <!-- 杜，新增底部备案号组件 -->
    <div>
      <Foot-bottom></Foot-bottom>
    </div>
  </div>

</template>

<script>
  import pinyin from 'pinyin'
  import HeadTop from '../components/headTop'
  import FootBottom from '../components/footBottom'
  import {
    mapGetters
  } from 'vuex'
  export default {
    // import引入的组件需要注入到对象中才能使用
    name: 'Manage',
    components: {
      HeadTop,
      FootBottom
    },
    data() {
      return {
        includeArr: [], // 杜，keepAlive缓存数组
        str1: '',
        str: '',
        title: '',
        title1: '',
        staffId: this.$store.getters.staffId,
        myGarden: this.$store.getters.gardenId,
        menuList: [], // menu的list
        editableTabsValue: 'homePage',
        editableTabs: [{
          title: '首页',
          route: 'homePage'
        }],
        openeds: [], // 打开tab数组
        changeGardens: '', // 修改小区
        isCollapse: false, // 默认菜单显示
        open_menu: '', // 展开的一级菜单
        query: {}, // 记录新路由后的query
        menuProArr: ['园区数字画像', '物业人员画像对比', '报事信息', '项目日历', '报表管理', 'APP住户管理', '任务管理', '设备管理', '检查标准', '员工离职', '物业人员管理',
          '抽审工单', '项目信息管理', '原始住户数据管理'
        ],
        filterText: '',
        popoverVisible: false,
        selectedName: '',
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        expandedKeys: [], // 存储需要展开的节点key
      }
    },
    computed: {
      ...mapGetters({
        theme: 'theme',
        tabList: 'tabList',
        myGardens: 'userGardenList',
        gardenAreaByStaffOrigin: 'gardenAreaByStaff'
      }),
      gardenAreaByStaff() {
        // 深拷贝，避免污染原数据
        let data = JSON.parse(JSON.stringify(this.gardenAreaByStaffOrigin))
        if (data && data.length > 0 && data[0].children && data[0].children.length > 0) {
          data[0].children.sort((a, b) => {
            // 获取name的拼音首字母
            const aPY = pinyin(a.name, {
              style: pinyin.STYLE_FIRST_LETTER
            }).map(i => i[0]).join('').toUpperCase()
            const bPY = pinyin(b.name, {
              style: pinyin.STYLE_FIRST_LETTER
            }).map(i => i[0]).join('').toUpperCase()
            return aPY.localeCompare(bPY)
          })
        }
        return data
      }
    },
    // 监控data中的数据变化
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val)
      },
      myGarden: function (newVal) {
        this.$store.commit('user/setGardenId', newVal)
        var data = this.myGardens.filter((i) => {
          if (i.id == newVal) {
            this.$store.commit('user/setIsRelationButton', i.isRelationButton)
            console.log(i.isRelationButton)
          }
        })
      },
      // 监听tab的列表
      editableTabs: {
        handler: function (val, oldVal) {
          // console.error('editableTabs===' + JSON.stringify(val))
          window.localStorage.setItem('tableTabs', JSON.stringify(this.editableTabs))
        },
        deep: true
      },
      // 监听tab列表的选中态
      editableTabsValue: {
        handler: function (val, oldVal) {
          console.log(val)
          // this.jumpOtherTabs(val)
          window.localStorage.setItem('tabsValue', JSON.stringify(this.editableTabsValue))
        },
        deep: true
      },
      // 监听菜单的选中态
      open_menu: {
        handler: function (val, oldVal) {
          window.localStorage.setItem('openMenu', JSON.stringify(this.open_menu))
        },
        deep: true
      },
      // 监听路由
      $route: {
        handler: function (val, oldVal) {
          console.log(val)
          console.log(val.meta.name)
          if (navigator.onLine || window.navigator.onLine === true) {
            // 记录下是否有参数
            this.query = val.query
            if (oldVal.name === 'homePage') {
              // 从首页跳转执行routeJump方法，添加tab页
              // 在首页跳转时，修正tab不选中bug
              // let changeRoute = val.path.split('/manage/')
              // this.routeJump(changeRoute[1], val.meta.name)
            }
            if (val.name === 'feeReceiveQuery' || val.name === 'feeActualQuery') {
              this.addKeepAliveInclude(val.name)
            }
            // 循环查找路由名称，相等就切换菜单的选中态
            for (var j = 0; j < this.editableTabs.length; j++) {
              // console.log(this.editableTabs[j].title)
              if (this.editableTabs[j].title === val.meta.name) {
                this.editableTabsValue = this.editableTabs[j].route
              }
            }
            // 需要跳转的页面
            if (val.name === 'personalInfo' || val.name ===
              'fullprojectAutoInspecRepoBackgroundDetail' || val.name === 'projectWideRepoInfoBackgroundDetail' ||
              val.name === '400backgroundDetail' || val.name === 'repoInfoBackgroundDetail' || val.name ===
              'liftManagementInfo' || oldVal.name === 'projectCalendarList' || val.name === 'trialOrderDetail' ||
              oldVal.name === 'hawkEyeOfParkList' || val.name === 'trialNotes' || val.name === 'trialDetailList' ||
              val.name === 'collectionRateDetail' || val.name === 'feeReceiveArrears' || val.name ===
              'feeReceivableRoomAndCar' || val.name === 'monthCollectOutside' ||
              val.name === 'feeReliefDetail' || val.name === 'feeAdvanceReceiptDetail' || val.name ===
              'feeReturnDetail' || val.name === 'feePayPrint' || val.name === 'hawkEyeOfParkList' || val.name ===
              'hawkEyeOfParkListNew' || val.name === 'propertyManageList' || val.name ===
              'preHouseholdInfoManageList' || val.name === 'carPackList' || val.name === 'projectWideRepoInfoList' ||
              val.name === 'repoInfoList' || val.name === 'fullprojectAutoInspecRepoList' || val.name ===
              'deviceManagementList' || val.name === 'liftManagementList' || val.name ===
              'accessControlEquipmentManagementList' || val.name === 'elevBluetoothEquipManagesList' || val.name ===
              'communityInfoManageList' || val.name === 'carUserList' || val.name === 'venueList' || val.name ===
              'contractList' || val.name === 'carInOutTmpList' || val.name === 'appHouseholdManageList') {
              // 已经存在tabs准备跳转
              this.title = val.name
              let isJump = false
              // 循环tabs列表，判断是否已经存在tab了
              for (var i = 0; i < this.editableTabs.length; i++) {
                if (this.editableTabs[i].title === val.meta.name) {
                  isJump = true
                }
              }
              if (isJump) {
                if (!this.$store.getters.userData) {
                  this.$message.error(this.$i18n.t('lang.lab_notOnload'))
                  this.$router.push({
                    name: 'login'
                  })
                } else {
                  this.$router.push({
                    name: val.name,
                    query: this.query
                  })
                  this.editableTabsValue = val.path
                  window.localStorage.setItem('tabsValue', JSON.stringify(this.editableTabsValue))
                }
              } else {
                if (!this.$store.getters.userData) {
                  this.$message.error(this.$i18n.t('lang.lab_notOnload'))
                  this.$router.push({
                    name: 'login'
                  })
                }
                if (this.editableTabs.length >= 10) {
                  this.$message.error('最多只能打开10个标签页，如要打开请先关闭')
                  this.$router.push({
                    name: oldVal.name
                  })
                } else {
                  this.editableTabs.push({
                    title: val.meta.name,
                    route: val.path,
                    query: val.query
                  })
                  window.localStorage.setItem('tableTabs', JSON.stringify(this.editableTabs))
                  this.$router.push({
                    name: val.name,
                    query: this.query
                  })
                  this.editableTabsValue = val.path
                  window.localStorage.setItem('tabsValue', JSON.stringify(this.editableTabsValue))
                }
              }
            }
            if (!this.$store.getters.userData) {
              this.$message.error(this.$i18n.t('lang.lab_notOnload'))
              this.$router.push({
                name: 'login'
              })
            }
            var menuId
            var aaa
            if (this.menuList.length > 0) {
              this.menuList.filter(function (item, index) {
                if (item.children && item.children.length > 0) {
                  item.children.filter(function (items, indexs) {
                    if (items.name === val.meta.name || items.route === val.matched[val.matched.length - 2]
                      .path.split('/manage/')[1]) {
                      menuId = items.id
                      aaa = items.id
                    }
                  })
                }
              })
              this.open_menu = menuId + ''
              if (val.matched && oldVal.matched && val.matched.length > 2 && oldVal.matched.length > 2 && val
                .matched[val.matched.length - 2].name === oldVal.matched[val.matched.length - 2].name) {
                this.open_menu = aaa + ''
              }
            }
            if (val.name === 'homePage') {
              this.open_menu = 'homePage'
            }
            window.localStorage.setItem('openMenu', JSON.stringify(this.open_menu))
          } else {
            this.$message.error(this.$i18n.t('lang.lab_Online'))
          }
        },
        deep: true
      },
    },
    // 方法集合
    methods: {
      // 处理全部小区点击
      handleAllGarden() {
        this.selectedName = '全部小区'
        this.myGarden = 0
        this.popoverVisible = false
        // 清除树的当前选中状态
        if (this.$refs.tree) {
          this.$refs.tree.setCurrentKey(null)
        }
        // 调用切换小区方法
        this.changeGarden(0)
      },
      // 树节点过滤方法
      filterNode(value, data) {
        if (!value) return true
        return data.name.indexOf(value) !== -1
      },

      // 处理节点点击
      handleNodeClick(data) {
        // 只处理三级节点
        if (!data.children || data.children.length === 0) {
          this.selectedName = data.name
          this.myGarden = data.id
          this.popoverVisible = false
          // 保存展开状态
          this.getParentKeys(data)
          // 调用切换小区方法
          this.changeGarden(data.id)
        }
      },

      // 初始化选中状态
      // initTreeSelection() {
      //   if (this.myGarden) {
      //     // 递归查找当前选中的节点
      //     const findNode = (nodes) => {
      //       for (let node of nodes) {
      //         if (node.id === this.myGarden) {
      //           this.selectedName = node.name
      //           // 获取所有父节点ID用于展开
      //           this.getParentKeys(node)
      //           return true
      //         }
      //         if (node.children && node.children.length > 0) {
      //           if (findNode(node.children)) return true
      //         }
      //       }
      //       return false
      //     }
      //     findNode(this.gardenAreaByStaff)
      //   }
      // },
      initTreeSelection() {
        if (this.myGarden === 0) {
          // 如果是全部小区
          this.selectedName = '全部小区'
          // 清除树的选中状态
          this.$nextTick(() => {
            if (this.$refs.tree) {
              this.$refs.tree.setCurrentKey(null)
              // 清除所有高亮状态
              this.$refs.tree.store.setCurrentNode(null)
            }
          })
        } else if (this.myGarden && this.gardenAreaByStaff) {
          // 递归查找当前选中的节点
          const findNode = (nodes) => {
            for (let node of nodes) {
              if (node.id === this.myGarden) {
                this.selectedName = node.name
                // 获取所有父节点name用于展开
                this.getParentKeys(node)
                // 确保DOM更新后设置当前选中节点
                this.$nextTick(() => {
                  if (this.$refs.tree) {
                    this.$refs.tree.setCurrentKey(node.name) // 使用name作为key来设置当前选中节点
                  }
                })
                return true
              }
              if (node.children && node.children.length > 0) {
                if (findNode(node.children)) return true
              }
            }
            return false
          }
          findNode(this.gardenAreaByStaff)
        }
      },

      // 获取父节点ID用于展开
      // getParentKeys(node, parentKeys = []) {
      //   if (node.parentId) {
      //     parentKeys.push(node.parentId)
      //     const parentNode = this.findParentNode(this.gardenAreaByStaff, node.parentId)
      //     if (parentNode) {
      //       this.getParentKeys(parentNode, parentKeys)
      //     }
      //   }
      //   this.expandedKeys = parentKeys
      // },
      getParentKeys(node, parentKeys = []) {
        // 使用数组收集所有父节点id
        const findParentNodes = (nodes, targetId, path = []) => {
          for (let item of nodes) {
            if (item.id === targetId) {
              return path
            }
            if (item.children && item.children.length > 0) {
              // 将当前节点添加到路径中
              const found = findParentNodes(item.children, targetId, [...path, item.name])
              if (found) {
                return found
              }
            }
          }
          return null
        }

        // 获取从根节点到目标节点的路径
        const parentPath = findParentNodes(this.gardenAreaByStaff, node.id)
        if (parentPath) {
          this.expandedKeys = parentPath
        }
      },

      // 查找父节点
      findParentNode(nodes, parentId) {
        for (let node of nodes) {
          if (node.id === parentId) return node
          if (node.children && node.children.length > 0) {
            const found = this.findParentNode(node.children, parentId)
            if (found) return found
          }
        }
        return null
      },
      // keep-alive 的 include 匹配的是组件 name，而不是路由 path；应收/实收查询需额外加入组件名
      resolveKeepAliveNames(routeOrPath) {
        if (!routeOrPath) {
          return []
        }
        var raw = String(routeOrPath)
        var names = []
        if (raw === 'feeReceiveQuery' || raw === 'feeActualQuery') {
          names.push(raw)
          return names
        }
        var route = raw
        if (route.indexOf('/manage/') === -1 && route !== 'homePage') {
          route = '/manage/' + route.replace(/^\//, '')
        }
        names.push(route)
        if (route.indexOf('main.feeReceive') > -1) {
          names.push('feeReceiveQuery')
        }
        if (route.indexOf('main.feeActual') > -1) {
          names.push('feeActualQuery')
        }
        return names
      },
      addKeepAliveInclude(routeOrPath) {
        var names = this.resolveKeepAliveNames(routeOrPath)
        for (var i = 0; i < names.length; i++) {
          if (this.includeArr.indexOf(names[i]) === -1) {
            this.includeArr.push(names[i])
          }
        }
        this.$keepAlive = this.includeArr
      },
      removeKeepAliveInclude(routeOrPath) {
        var names = this.resolveKeepAliveNames(routeOrPath)
        for (var i = 0; i < names.length; i++) {
          var index = this.includeArr.indexOf(names[i])
          if (index > -1) {
            this.includeArr.splice(index, 1)
          }
        }
        console.log(this.includeArr)
        this.$keepAlive = this.includeArr
      },
      // 点击关闭标签
      removeTab(targetName) {
        console.log(targetName)
        // 杜，keepAlive（同时移除路由路径与组件名，避免残留缓存）
        this.removeKeepAliveInclude(targetName)

        if (navigator.onLine || window.navigator.onLine === true) {
          if (targetName != 'homePage') {
            let tabs = this.editableTabs
            console.log(this.editableTabs)
            let activeName = this.editableTabsValue
            // 杜，修改点击tab园区鹰眼不关闭bug，↑的注释的↑是修改前
            // let activeName = this.editableTabsValue.replace('/manage/', '')
            console.log(activeName)
            // 杜，修改点击tab园区鹰眼不关闭bug end

            if (activeName === targetName) {
              tabs.forEach((tab, index) => {
                if (tab.route === targetName) {
                  let nextTab = tabs[index + 1] || tabs[index - 1]
                  if (nextTab) {
                    activeName = nextTab.route
                  }
                }
              })
            }
            this.editableTabsValue = activeName
            window.localStorage.setItem('tabsValue', JSON.stringify(this.editableTabsValue))
            for (var j = 0; j < this.editableTabs.length; j++) {
              if (this.editableTabs[j].route == this.editableTabsValue) {
                this.$router.push({
                  path: this.editableTabs[j].route,
                  query: this.editableTabs[j].query
                })
              }
            }
            if (this.editableTabs.length === 1) {
              this.$router.push({
                path: 'homePage'
              })
            }
            this.editableTabs = tabs.filter(tab => tab.route != targetName)
            window.localStorage.setItem('tableTabs', JSON.stringify(this.editableTabs))
          } else {
            this.$message.error('您还没有打开标签!')
          }
        } else {
          this.$message.error(this.$i18n.t('lang.lab_Online'))
        }
      },
      // 点击切换按钮，更改路由跳转
      jumpOtherTabs(route) {
        // 杜，keepAlive：切回 tab 时确保组件名在 include 中，避免销毁重建导致页面刷新
        this.addKeepAliveInclude(route)
        if (navigator.onLine || window.navigator.onLine === true) {
          let isJump = false
          // var str = window.location.href
          // if (str && str.indexOf('/manage')) {
          //   var start = str.indexOf('/manage')
          //   var str2 = str.substring(start)
          //   this.str = str2
          // }
          // if (this.title && route) {
          //   for (var K = 0; K < this.editableTabs.length; K++) {
          //     if (this.editableTabs[K].title == this.title) {
          //       this.editableTabs[K].route = route
          //     }
          //   }
          // }
          for (var i = 0; i < this.editableTabs.length; i++) {
            if (this.editableTabs[i].route === this.editableTabsValue) {
              var newQuery = this.editableTabs[i].query
              this.title = this.editableTabs[i].title
              if (this.editableTabs[i].query && this.editableTabs[i].query != '') {
                this.$router.push({
                  path: route,
                  query: this.editableTabs[i].query
                })
              } else {
                this.$router.push({
                  path: route,
                  query: this.editableTabs[i].query
                })
              }
            }
          }
          if (isJump) {
            if (!this.$store.getters.userData) {
              this.$message.error(this.$i18n.t('lang.lab_notOnload'))
              this.$router.push({
                path: ''
              })
            } else {
              this.$router.push({
                path: route,
                query: newQuery
              })
            }
          }
          var menuId
          this.menuList.filter(function (item, index) {
            if (item.children && item.children.length > 0) {
              item.children.filter(function (items, indexs) {
                if (items.route === route) {
                  menuId = items.id
                }
              })
            }
          })
          this.open_menu = menuId + ''
          window.localStorage.setItem('openMenu', JSON.stringify(this.open_menu))
          if (!this.$store.getters.userData) {
            this.$message.error(this.$i18n.t('lang.lab_notOnload'))
            this.$router.push({
              name: 'login'
            })
          }
        } else {
          this.$message.error(this.$i18n.t('lang.lab_Online'))
        }
      },
      // 点击左侧菜单跳转
      routeJump(path, name) {
        // console.error(path)
        // console.error(name)
        if (path == 'main.zljexe') {
          window.location.href = 'ZLJ://'
        } else {
          var route = '/manage/' + path
          // 杜，keepAlive：同时缓存路由路径和组件名（keep-alive 的 include 匹配组件 name）
          this.addKeepAliveInclude(route)
          // console.log(this.$keepAlive)
          // alert(route)
          // debugger
          if (navigator.onLine || window.navigator.onLine === true) {
            // var str1 = window.location.href
            // if (str1 && str1.indexOf('/manage')) {
            //   var start = str1.indexOf('/manage')
            //   var str2 = str1.substring(start)
            //   this.str1 = str2
            // }
            // console.error(this.str1)
            // this.title = name
            // // 快捷方式切换首页问题（之前在 this.title = name 上边）
            // if (this.title && route) {
            //   console.log(this.title)
            //   console.log(this.editableTabs[1])
            //   for (var k = 0; k < this.editableTabs.length; k++) {
            //     console.log(this.editableTabs[k].title)
            //     if (this.editableTabs[k].title == this.title) {
            //       alert(1)
            //       this.editableTabs[k].route = route
            //       // console.log(this.editableTabs[K].route)
            //     }
            //   }
            // }
            // 判断是否存在tabs
            var isExistence = true
            // 已经存在tabs准备跳转
            let isJump = false
            // 循环tabs列表，判断是否已经存在tab了
            for (var i = 0; i < this.editableTabs.length; i++) {
              if (this.editableTabs[i].title === name) {
                this.title = this.editableTabs[i].title
                var newQuery = this.editableTabs[i].query
                isExistence = false
                isJump = true
              }
            }
            if (isJump) {
              for (var j = 0; j < this.editableTabs.length; j++) {
                if (this.editableTabs[j].title === name) {
                  this.title = this.editableTabs[j].title
                  this.editableTabsValue = this.editableTabs[j].route
                }
              }
              if (!this.$store.getters.userData) {
                this.$message.error(this.$i18n.t('lang.lab_notOnload'))
                this.$router.push({
                  name: 'login'
                })
              } else {
                this.$router.push({
                  path: path,
                  query: newQuery
                })
                this.editableTabsValue = route
                window.localStorage.setItem('tabsValue', JSON.stringify(this.editableTabsValue))
              }
            } else {
              if (isExistence) {
                if (this.editableTabs.length >= 10) {
                  this.$message.error(this.$i18n.t('lang.lab_openTenMax'))
                } else {
                  if (!this.$store.getters.userData) {
                    this.$message.error(this.$i18n.t('lang.lab_notOnload'))
                    this.$router.push({
                      name: 'login'
                    })
                  } else {
                    if (path === 'personalInfo') {
                      path = '/manage/personalInfo'
                    }
                    this.editableTabs.push({
                      title: name,
                      route: path,
                      query: newQuery
                    })
                    window.localStorage.setItem('tableTabs', JSON.stringify(this.editableTabs))
                    this.editableTabsValue = route
                    window.localStorage.setItem('tabsValue', JSON.stringify(this.editableTabsValue))
                    this.$router.push({
                      path: path,
                      query: newQuery
                    })
                  }
                }
              }
            }
            this.title = name
            // 快捷方式切换首页问题（之前在 this.title = name 上边）
            if (this.title && route) {
              for (var k = 0; k < this.editableTabs.length; k++) {
                if (this.editableTabs[k].title == this.title) {
                  this.editableTabs[k].route = route
                }
              }
            }
            var menuId
            this.menuList.filter(function (item, index) {
              if (item.children && item.children.length > 0) {
                item.children.filter(function (items, indexs) {
                  if (items.name === name) {
                    menuId = items.id
                  }
                })
              }
            })
            this.open_menu = menuId + ''
            window.localStorage.setItem('openMenu', JSON.stringify(this.open_menu))
          } else {
            this.$message.error(this.$i18n.t('lang.lab_Online'))
          }
        }
      },
      // tabs操作栏
      handleCommand(command) {
        if (navigator.onLine || window.navigator.onLine === true) {
          if (command === 'a') {
            this.removeTab(this.editableTabsValue)
          } else if (command === 'b') {
            // 关闭所有tabs
            this.editableTabs = [{
              title: '首页',
              route: 'homePage'
            }]
            this.includeArr = [] // 杜，keepAlive
            this.$keepAlive = [] // 杜，keepAlive
            this.$router.push({
              path: 'homePage'
            })
            this.editableTabsValue = 'homePage'
            window.localStorage.setItem('tabsValue', JSON.stringify(this.editableTabsValue))
          }
        } else {
          this.$message.error(this.$i18n.t('lang.lab_Online'))
        }
      },
      checkLogin() {
        const menuLists = [...this.$store.getters.userMunuList]
        // 非管理员
        if (menuLists.length === 1) {
          this.menuList = menuLists[0]
        }
        // 管理员
        if (menuLists.length > 1) {
          this.menuList = menuLists[1]
        }
        for (var i = 0; i < this.menuList.length; i++) {
          if (this.menuList[i].children && this.menuList[i].children.length > 1) {
            for (var j = 0; j < this.menuList[i].children.length; j++) {
              if (this.menuList[i].children[j].route.indexOf('orgDepartment') != -1) {
                this.menuList[i].children[j].route = 'main.orgDepartment'
              }
              if (this.menuList[i].children[j].route.indexOf('pivot') != -1) {
                if (this.menuList[i].children[j].route.indexOf('0') != -1) {
                  this.menuList[i].children[j].route = 'main.pivot0'
                }
                if (this.menuList[i].children[j].route.indexOf('1') != -1) {
                  this.menuList[i].children[j].route = 'main.pivot1'
                }
                if (this.menuList[i].children[j].route.indexOf('2') != -1) {
                  this.menuList[i].children[j].route = 'main.pivot2'
                }
                if (this.menuList[i].children[j].route.indexOf('3') != -1) {
                  this.menuList[i].children[j].route = 'main.pivot3'
                }
              }
              if (this.menuList[i].children[j].route.indexOf('gardenvacant') != -1) {
                if (this.menuList[i].children[j].route.indexOf('1') != -1) {
                  this.menuList[i].children[j].route = 'main.gardenvacant1'
                }
              }
              if (this.menuList[i].children[j].route.indexOf('garden(') != -1) {
                if (this.menuList[i].children[j].route.indexOf('1') != -1) {
                  this.menuList[i].children[j].route = 'main.garden1'
                }
              }
              if (this.menuList[i].children[j].route.indexOf('maintainType') != -1) {
                if (this.menuList[i].children[j].route.indexOf('1') != -1) {
                  this.menuList[i].children[j].route = 'main.maintainType1'
                }
              }
              if (this.menuList[i].children[j].route.indexOf('contractType') != -1) {
                if (this.menuList[i].children[j].route.indexOf('1') != -1) {
                  this.menuList[i].children[j].route = 'main.contractType1'
                }
              }
              if (this.menuList[i].children[j].route.indexOf('paidServiceType') != -1) {
                if (this.menuList[i].children[j].route.indexOf('1') != -1) {
                  this.menuList[i].children[j].route = 'main.paidServiceType1'
                }
              }
            }
          }
        }
      },
      // 更换小区下拉
      changeGarden(value) {
        this.includeArr = [] // 杜，keepAlive
        this.$keepAlive = [] // 杜，keepAlive
        this.openeds = ['1']
        this.open_menu = 'homePage'
        const menuLists = [...this.$store.getters.userMunuList]

        if (menuLists.length > 1) {
          if (value === 0) {
            this.menuList = menuLists[1]
            this.editableTabs = [{
              title: '首页',
              route: 'homePage',
              close: 'closable'
            }]
            this.$router.push({
              path: 'homePage'
            })
            this.editableTabsValue = 'homePage'
          } else {
            this.menuList = menuLists[0]
            for (var i = 0; i < this.menuList.length; i++) {
              if (this.menuList[i].children && this.menuList[i].children.length > 1) {
                for (var j = 0; j < this.menuList[i].children.length; j++) {
                  if (this.menuList[i].children[j].route.indexOf('pivot') != -1) {
                    if (this.menuList[i].children[j].route.indexOf('0') != -1) {
                      this.menuList[i].children[j].route = 'main.pivot0'
                    }
                    if (this.menuList[i].children[j].route.indexOf('1') != -1) {
                      this.menuList[i].children[j].route = 'main.pivot1'
                    }
                    if (this.menuList[i].children[j].route.indexOf('2') != -1) {
                      this.menuList[i].children[j].route = 'main.pivot2'
                    }
                    if (this.menuList[i].children[j].route.indexOf('3') != -1) {
                      this.menuList[i].children[j].route = 'main.pivot3'
                    }
                  }
                  if (this.menuList[i].children[j].route.indexOf('gardenvacant') != -1) {
                    if (this.menuList[i].children[j].route.indexOf('1') != -1) {
                      this.menuList[i].children[j].route = 'main.gardenvacant1'
                    }
                  }
                  if (this.menuList[i].children[j].route.indexOf('garden(') != -1) {
                    if (this.menuList[i].children[j].route.indexOf('1') != -1) {
                      this.menuList[i].children[j].route = 'main.garden1'
                    }
                  }
                  if (this.menuList[i].children[j].route.indexOf('contractType') != -1) {
                    if (this.menuList[i].children[j].route.indexOf('1') != -1) {
                      this.menuList[i].children[j].route = 'main.contractType1'
                    }
                  }
                }
              }
            }
            this.editableTabs = [{
              title: '首页',
              route: 'homePage',
              close: 'closable'
            }]
            this.$router.push({
              path: 'homePage'
            })
            this.editableTabsValue = 'homePage'
          }
        } else {
          this.menuList = menuLists[0]
          this.editableTabs = [{
            title: '首页',
            route: 'homePage',
            close: 'closable'
          }]
          this.$router.push({
            path: 'homePage'
          })
          this.editableTabsValue = 'homePage'
        }
        window.localStorage.setItem('tabsValue', JSON.stringify(this.editableTabsValue))
        window.localStorage.setItem('tableTabs', JSON.stringify(this.editableTabs))
        // 杜，新增，切换小区时清空缓存（timeOut原因：destroyed在changeGarden后执行）
        setTimeout(function () {
          sessionStorage.clear()
        }, 500)
      },
    },
    // 加判断，localStorage是否为空，空跳转登录页
    created() {
      this.initTreeSelection()
      console.log(this.$keepAlive)
      this.includeArr = this.$keepAlive
      this.checkLogin()
      this.changeGarden(this.myGarden)
      this.open_menu = 'homePage'
      if (JSON.parse(localStorage.getItem('tableTabs'))) {
        this.editableTabs = JSON.parse(localStorage.getItem('tableTabs'))
        this.editableTabsValue = JSON.parse(localStorage.getItem('tabsValue'))
        this.open_menu = JSON.parse(localStorage.getItem('openMenu'))
      }
    }
  }
</script>

<style lang='scss'>
  .manage {
    /* background-color: #f2f3f5; */
    background-color: #ffffff;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: hidden;

    // 设置第一个标签不可关闭
    .el-tabs__nav .el-tabs__item:nth-child(1) span {
      display: none;
    }

    .home {
      padding-left: 10px !important;
      font-size: 16px !important;
      height: 48px !important;
      line-height: 48px !important;
      background: rgba(0, 0, 0, 0) !important;

      i {
        opacity: inherit;
        margin-right: 6px;
        margin-left: 14px;
        font-size: 20px;
        color: inherit;
        vertical-align: middle;
      }

      span {
        font-size: 16px;
      }
    }

    .top {
      background-color: #f2f3f5;
    }

    .hiddenBtn {
      position: absolute;
      right: -24px;
      top: 116px;
      z-index: 0;
      width: 24px;
      height: 48px;
      line-height: 48px;
      border-radius: 0 48px 48px 0;
      cursor: pointer;
      background: linear-gradient(90deg, #112d70, #205fbc);
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;

      .iconicon {
        color: #ffffff;
        font-size: 22px;
        font-weight: 700;
      }

      .el-icon-arrow-left:before {
        content: "\e6e0";
      }

      .el-icon-arrow-right:before {
        content: "\e6de";
      }
    }

    .gardenSelect {
      margin-bottom: 10px;
      width: 200px;
      margin-left: 10px;
      margin-top: 10px;
    }

    .el-container {
      // 杜，增加备案号修改样式
      // height: 100%;
      height: 88%;
    }

    .el-main {
      margin-top: 40px;
      margin-bottom: 20px;
    }

    .el-tabs__nav-wrap {
      position: fixed;
      background-color: #ffffff;
      max-width: 76%;
      z-index: 500;
      border-bottom: solid 1px #f2f3f5;
    }

    .el-tabs__nav-scroll {
      background-color: white;

      .el-tabs__nav.is-top {
        border: none;

        .el-tabs__item {
          border-left: none;
          border-right: 1px solid #e4e7ed !important;
        }
      }
    }

    .el-header {
      padding: 0px;
      height: 48px !important;
    }

    .el-menu {
      border-right: solid 0px #e6e6e6;
    }

    .el-aside {
      .el-menu-vertical-demo:last-child {
        margin-bottom: 50px;
      }
    }

    .el-menu-item i {
      vertical-align: text-top;
    }

    .sidebar {
      // 杜，增加备案号修改样式
      // height: 94%;
      height: 98%;
      display: flex;
      flex-direction: column;
      position: relative;
      z-index: 1;
      margin-bottom: 20px;
      border-radius: 6px;
    }

    // 二级菜单正常灰色度0.15
    .el-aside {
      .el-menu-vertical-demo {
        .home:first-child {
          background: rgba(0, 0, 0, 0) !important;
        }

        .home:first-child.is-active {
          background: rgba(0, 0, 0, 0.3) !important;
        }
      }
    }

    .el-menu-item {
      background: rgba(0, 0, 0, .15) !important;
    }

    .el-submenu {
      .el-submenu__title {
        padding-left: 10px !important;
        font-size: 16px !important;
        height: 48px !important;
        line-height: 48px !important;

        .iconfont {
          margin-right: 6px;
          margin-left: 14px;
          font-size: 20px;
        }
      }
    }

    // 二级菜单选中态0.3
    .el-menu-item.is-active {
      background: rgba(0, 0, 0, .3) !important;
    }

    .z-aside {
      width: auto !important;
      // 杜，增加备案号修改样式
      // height: calc(100vh - 100px);
      height: 92%;
      color: $c-not-active;
      text-align: left;
      background: url('../assets/imgs/aside.png') left bottom no-repeat;
      background-size: 100% auto;

      .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 220px;
      }
    }

    .el-menu-item {
      border-radius: 0px !important;
    }

    .z-aside::-webkit-scrollbar {
      display: none
    }

    .el-menu-item {
      background-color: $c-side-tint;
      color: $c-not-active;
      min-width: 0;
    }

    .el-menu-item.is-active {
      color: $c-active !important;
    }

    .el-tabs__header {
      margin: 0;
    }

    .el-container {
      // height: 98%;
      background: #ffffff;
    }

    .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
      border: none;
    }

    .el-tabs {
      height: auto;
      overflow: auto;
      background-color: #f2f3f5;
    }

    .el-menu {
      background-color: transparent !important;
      border: none !important;
    }

    .el-submenu__title {
      color: #fff;
      opacity: .8;

      &:hover,
      &:focus {
        background-color: transparent;
      }

      .icon {
        margin-right: 20px;
      }

      i {
        color: inherit;
        opacity: inherit;
        font-size: 18px;
      }
    }

    .el-submenu:hover {
      .el-submenu__title {
        opacity: 1;
        background-color: transparent;
        border-radius: 6px;
      }
    }

    .is-opened {
      .el-submenu__title {
        opacity: 1;
        border-radius: 6px;
      }
    }

    .el-submenu .el-menu-item {
      height: 40px;
      line-height: 40px;
    }

    .el-menu-item {
      color: #fff;
      opacity: .8;
      font-size: 12px;
      border-radius: 6px;
      padding-left: 20px;
      background-color: transparent;

      &.is-active,
      &:hover,
      &:focus {
        opacity: 1;
        color: #fff;
        background: rgba(0, 0, 0, .2);
      }
    }

    .el-submenu {
      .el-menu--inline {
        .el-menu-item {
          padding-left: 58px !important;
        }
      }
    }

    .closeTabs {
      position: absolute;
      right: 20px;
      margin-top: 10px;
      cursor: pointer;
      z-index: 700;
    }
  }

  // 删除弹框默认的透过度
  .el-loading-mask {
    background-color: hsla(0, 0%, 100%, 0.1) !important;
  }

  .el-menu--vertical {
    background-color: #00a8bb;
    border-radius: 4px;

    ul {
      background-color: #00a8bb;
      border-radius: 4px;

      li {
        background-color: #00a8bb;
        border-radius: 4px;
        height: 40px;
        line-height: 40px;
      }

      li:hover {
        background: rgba(0, 0, 0, .15);
      }
    }
  }

  // 下面的css与弹框的样式有一点冲突
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  // 定义滚动条轨道 内阴影+圆角
  ::-webkit-scrollbar-track {
    border-radius: 10px;
  }

  // 定义滑块 内阴影+圆角
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.25);
  }

  ::-webkit-scrollbar-thumb {
    border-right: 1px solid #ffffff;
  }

  .manage .menuPro {
    color: #ee728b !important;
    opacity: 1 !important;
    font-size: 14px !important;
    font-weight: bold;
    margin-left: -29px;

    &.is-active,
    &:hover,
    &:focus {
      color: #ee728b !important;
    }
  }

  .el-icon-star-on {
    color: #ee728b !important;
  }

  /* 树容器样式 */
  .el-tree {
    width: 100%;
    height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .el-popover {
    padding: 12px;
    min-width: 220px;
    width: 180px !important;
    /* 强制设置宽度 */
  }

  /* 调整select宽度以匹配popover */
  .gardenSelect {
    margin-bottom: 10px;
    width: 196px !important;
    /* 减去padding以适应popover宽度 */
    margin-left: 10px;
    margin-top: 10px;
  }

  /* 自定义树容器的滚动条样式 */
  .el-tree::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  .el-tree::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: #c0c4cc;
  }

  .el-tree::-webkit-scrollbar-track {
    border-radius: 3px;
    background: #f5f7fa;
  }

  .el-tree-node__content {
    height: 32px;
  }

  .el-tree-node.is-current>.el-tree-node__content {
    background-color: #f5f7fa;
    color: #409EFF;
  }

  /* 处理hover状态 */
  .el-tree-node__content:hover {
    background-color: #f5f7fa;
  }

  /* 调整popover样式 */
  .el-popover {
    padding: 12px;
    min-width: 180px;
  }

  /* 全部小区选项样式 */
  .all-garden {
    height: 32px;
    line-height: 32px;
    padding: 0 10px 0 4px;
    cursor: pointer;
    margin-bottom: 8px;

    &:hover {
      background-color: #f5f7fa;
    }

    &.is-selected {
      background-color: #f5f7fa;
      color: #409EFF !important;

      span {
        color: #409EFF !important;
      }
    }

    span {
      font-size: 14px;
      color: #606266;
    }
  }
  .gardenSelect span {
    color: #606266;
    font-size: 14px;
    line-height: 32px;
    height: 32px;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: middle;
    padding-left: 0;
    padding-right: 0;
  }
  .gardenSelect .el-icon-arrow-down {
    transition: transform 0.3s cubic-bezier(.645,.045,.355,1);
  }
</style>